import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  Account,
  AccountGroupMembership,
} from '@libs/src/models/account.model';
import { Group } from '@libs/src/models/group.model';

import find from 'lodash-es/find';
import get from 'lodash-es/get';
import has from 'lodash-es/has';
import isEqual from 'lodash-es/isEqual';
import pick from 'lodash-es/pick';

const GroupMembershipApiUrl = (
  groupOrGroupId: string | Group,
  account: Account,
) =>
  `/api/v2/groups/${
    'string' === typeof groupOrGroupId ? groupOrGroupId : groupOrGroupId._id
  }/accounts/${account._id}`;

@Injectable()
export class AccountHubsEditService {
  constructor(private http: HttpClient) {}

  updateMembership(
    account: Account,
    membership: AccountGroupMembership,
    update: any,
  ) {
    if (has(update, 'role')) {
      const groupRoles = membership.document?.roles;
      const oldRoleConfig = find(groupRoles, (role) =>
        isEqual(role.name, membership.role),
      );
      const chosenRoleConfig = find(groupRoles, (role) =>
        isEqual(role.name, update.role),
      );

      const defaults = oldRoleConfig?.defaults ?? {};
      const shouldUpdateOtherFields = isEqual(
        pick(membership, Object.keys(defaults)),
        defaults,
      );

      if (shouldUpdateOtherFields && has(chosenRoleConfig, 'defaults')) {
        const fieldsToInherit = ['expert_status', 'inviteable', 'searchable'];
        update = {
          ...update,
          ...pick(chosenRoleConfig?.defaults, fieldsToInherit),
        };
      }
    }
    if (has(update, 'expert_status')) {
      update.searchable = isEqual('approved', update.expert_status);
    }
    return this.http.put(
      GroupMembershipApiUrl(membership.document, account),
      update,
    );
  }

  deleteMembership(account: Account, membership: AccountGroupMembership) {
    return this.http.delete(
      GroupMembershipApiUrl(membership.document, account),
    );
  }
}
